module.exports = __webpack_public_path__ + "img/icon2.5b8a0238.png";